<template>
    <article :id="option.optionId" @click="vote"
             class="poll-text__option poll-option" ref="option"
             :class="{'active' : active }"
             v-if="isTextTemplate"
             >
      <template>
        <span class="poll-text__title" ref="title">{{ option.title }}</span>

        <div class="poll-text__percent"
             v-if="showResults"
             :style="{ left : `${percentStyle}px` }">
          {{ percent }}<span>%</span>
        </div>
        <div class="poll-text__fill" ref="fill" v-if="showResults" :style="{ width : `${percent}%` }"></div>
      </template>
      <span
        v-if="showNumberVotesPerResponse"
        class="poll-text__votes">{{ numOptionVotes }} votos
      </span>
    </article>

  <article :id="option.optionId" class="poll-image__option" @click="$emit('click', option)" v-else>
    <div
      v-if="showResults"
      class="poll-image__percent">{{ percent }}<span>%</span>
    </div>

    <div class="poll-option poll-image__image"
         :class="{'active' : active }">
      <div v-if="showResults" class="poll-image__image__fill" :style="{height: `${percent}%`}"></div>
      <img :src="option.imageUrl" :alt="option.title">
    </div>
    <span class="poll-image__title">{{ option.title }}</span>
    <span
      v-if="showNumberVotesPerResponse"
      class="poll-image__votes">{{ numOptionVotes }} votos
    </span>
  </article>
</template>

<script>
  export default {
    props: {
      option: Object,
      showNumberVotesPerResponse: Number,
      showResults: Number,
      template: String,
      isTextTemplate: Boolean,
      active: Boolean,
      loading: Boolean
    },
    data() {
      return {
        percentStyle: 0
      }
    },
    methods: {
      vote() {
        if (!this.loading) {
          this.$emit('click', this.option)
        }
      },
      // Este método tiene el prefijo _ para simular método privado
      // su intención es refrescar la posición del porcentaje de una opción
      // esto es porque esta posición puede variar, en función de la longitud
      // del texto o el porcentaje. Por ejemplo si tiene 90% y ponemos el 90%
      // justo después del limite de la barra 'fill' que representa el porcentaje
      // éste se saldría de la barra y quedaría feo, por eso lo calculamos
      // basándonos en longitudes de elementos.
      _updatePercentPosition() {
        if (this.isTextTemplate) {
          const totalWidth = this.$el.clientWidth;
          const titleWidth = this.$el.querySelector(".poll-text__title").clientWidth;
          const fillWidth = this.$el.querySelector(".poll-text__fill").clientWidth;
          const fillWidthPercent = (fillWidth/totalWidth *100).toFixed(2);

          if(fillWidth <= titleWidth) {
            this.percentStyle = titleWidth + 20;
          } else {
            if (fillWidthPercent > 87) {
              this.percentStyle = fillWidth - 35;
              this.$el.querySelector(".poll-text__percent")?.classList?.add("white"); // TODO
            } else {
              this.percentStyle = fillWidth + 12;
              this.$el.querySelector(".poll-text__percent")?.classList?.remove("white"); // TODO
            }
          }
        }
      },
    },
    mounted() {
      this._updatePercentPosition();
    },
    computed: {
      numOptionVotes() {
        return `${this.option.numVotes}`.replace('.', ',');
      },
      percent() {
        return Math.round(this.option.percent);
      },
    },
    watch: {
      option(v) {
        // Nexttick porque sino cuando se ejecuta la funcion para actualizar
        // la posicion del porcentaje recoge el valor sin actualizar
        this.$nextTick(() => {
          this._updatePercentPosition();
        });
      },
    },
  }
</script>
